import { useEffect } from "react";

export function usePageLoading(isLoading: boolean) {
  useEffect(() => {
    const className = "page-loading";
    if (isLoading) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }

    return () => document.body.classList.remove(className);
  }, [isLoading]);
}
